import styled from 'styled-components';
import {colorTheme} from '../../../ui-toolkit';
import {imgSetup, imgSize} from '../../img/logo/logoImgSetup';

export const ClientLogo = styled.img`
    ${imgSetup({})};
    ${imgSize({
        margin: '0 0 50px',
        width: '120px',
    })};
    pointer-events: none;
`;

export const BrandLogo = styled.div`
    position: fixed;
    z-index: 10;
    bottom: 40px;
    left: var(--login-grid-horz-padding);
    height: 50px;
    pointer-events: none;
    height: 54px;
    background: var(--logo-01);
    width: 132px;
    background-size: contain;
    background-repeat: no-repeat;
`;

export const CompanyLogo = styled.div`
    ${({src}) =>
        colorTheme({
            '--currentLogo': {
                dark: `url(${src.dark})`,
                light: `url(${src.light})`,
            },
        })}
    z-index: 10;
    height: 50px;
    pointer-events: none;
    height: 54px;
    background: var(--currentLogo);
    width: 132px;
    background-size: contain;
    background-repeat: no-repeat;
`;

export const ResellerLogo = styled.div`
    ${({src}) =>
        colorTheme({
            '--currentLogo': {
                dark: `url(${src.dark})`,
                light: `url(${src.light})`,
            },
        })}
    position: fixed;
    bottom: 40px;
    right: var(--login-grid-horz-padding);
    z-index: 10;
    height: 50px;
    pointer-events: none;
    height: 54px;
    background: var(--currentLogo);
    width: 132px;
    background-size: contain;
    background-repeat: no-repeat;
`;
